// extracted by mini-css-extract-plugin
export default {"background":"login_background__CdWja","loginCard":"login_loginCard__T5uyh"};